module.exports = __webpack_public_path__ + "img/badge-app-store.8c177b28.svg";